module.exports = __webpack_public_path__ + "img/img_11.6eb0f1ae.png";